import { render, staticRenderFns } from "./CoMatch.vue?vue&type=template&id=42711a4d&"
import script from "./CoMatch.vue?vue&type=script&lang=ts&"
export * from "./CoMatch.vue?vue&type=script&lang=ts&"
import style0 from "./CoMatch.vue?vue&type=style&index=0&id=42711a4d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports